const containerSearch = {
  p: '6px 8px',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  color: '#d2d2d2',
  borderRadius: '8px',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  boxSizing: 'border-box',
};

export default {
  containerSearch,
};
